export * from './IconSearchStroked';
